import React, { Component } from "react"

export default class Aptitfilms extends Component {
  render() {
  return (
    <div className="aptitoptions">
      <a href="https://en.wikipedia.org/wiki/The_Money_Store_(album)" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Money Store</p></a>
      <a href="https://en.wikipedia.org/wiki/Grid_of_Points" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Grid of Points</p></a>
      <a href="https://en.wikipedia.org/wiki/Luxury_Problems_(Andy_Stott_album)" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Luxury Problems</p></a>
      <a href="https://en.wikipedia.org/wiki/Boy_Harsher" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Lesser Man</p></a>
      <a href="https://en.wikipedia.org/wiki/2012%E2%80%932017" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; 2012 - 2017</p></a>
      <a href="https://en.wikipedia.org/wiki/The_Renderers_(band)" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; In The Sodium Light</p></a>
      <a href="https://en.wikipedia.org/wiki/Some_Rap_Songs" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Some Rap Songs</p></a>
      <a href="https://en.wikipedia.org/wiki/Injury_Reserve" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Injury Reserve</p></a>
    </div>
  )
}
}

